import React from 'react';
import { motion } from 'framer-motion';

// Define badge criteria (copying from Dashboard for now - consider a shared constants file later)
const badgeCriteria = [
    { id: 'subtopic-conqueror', type: 'completion', target: 'subtopic', count: 1, name: 'Subtopic Conqueror', description: 'Completed 1 subtopic.' },
    { id: 'subtopic-streak', type: 'completion', target: 'subtopic', count: 5, name: 'Subtopic Streak', description: 'Completed 5 subtopics.' },
    { id: 'skill-achiever', type: 'completion', target: 'skill', count: 1, name: 'Skill Achiever', description: 'Completed 1 skill.' },
    { id: 'resource-explorer', type: 'engagement', target: 'resource', count: 1, name: 'Resource Explorer', description: 'Added 1 learning resource.' },
    { id: 'note-taker', type: 'engagement', target: 'notes', count: 1, name: 'Note Taker', description: 'Added notes to 1 subtopic.' },
    { id: 'subtopic-master', type: 'completion', target: 'subtopic', count: 10, name: 'Subtopic Master', description: 'Completed 10 subtopics.' },
    { id: 'skill-enthusiast', type: 'completion', target: 'skill', count: 3, name: 'Skill Enthusiast', description: 'Completed 3 skills.' },
    { id: 'skill-mastermind', type: 'completion', target: 'skill', count: 5, name: 'Skill Mastermind', description: 'Completed 5 skills.' },
    { id: 'resource-curator', type: 'engagement', target: 'resource', count: 5, name: 'Resource Curator', description: 'Added 5 learning resources.' },
    { id: 'knowledge-linker', type: 'engagement', target: 'resource', count: 10, name: 'Knowledge Linker', description: 'Added 10 learning resources.' },
    { id: 'detailed-notetaker', type: 'engagement', target: 'notes', count: 3, name: 'Detailed Notetaker', description: 'Added notes to 3 subtopics.' },
    { id: 'knowledge-documenter', type: 'engagement', target: 'notes', count: 5, name: 'Knowledge Documenter', description: 'Added notes to 5 subtopics.' },
];

export default function BadgesPage() {
    // Group badges by type for better organization
    const groupedBadges = badgeCriteria.reduce((acc, badge) => {
        (acc[badge.type] = acc[badge.type] || []).push(badge);
        return acc;
    }, {});

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="container mx-auto p-6 space-y-8"
        >
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">All Badges</h1>
            
            <p className="text-gray-600 dark:text-gray-400">Discover all the badges you can earn and how to achieve them as you progress in your learning journey!</p>

            {Object.entries(groupedBadges).map(([type, badges]) => (
                <div key={type} className="space-y-4">
                    <h2 className="text-2xl font-semibold text-gray-900 dark:text-white capitalize">{type} Badges</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {badges.map(badge => (
                            <div key={badge.id} className="card flex flex-col items-start">
                                {/* Replace with actual badge icon/image when available */}
                                <div className="text-4xl mb-2">🏆</div> 
                                <h3 className="text-lg font-medium text-gray-900 dark:text-white">{badge.name}</h3>
                                <p className="text-gray-600 dark:text-gray-400 text-sm">{badge.description}</p>
                                {/* Optional: Add more details like progress towards the badge if user data was available here */}
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </motion.div>
    );
} 